import axios from "axios";

// Allow callers to omit the options parameter by providing a default empty object
// so that destructuring its properties does not throw an error when undefined.
async function fetchAPI(relativePath, options = {}) {
  const res = await axios(`${process.env.NEXT_PUBLIC_BASE_URL}${relativePath}`, {
    ...options,
    withCredentials: true,
    headers: { ...options.headers, Accept: "application/json" },
  });
  return res.data;
}

export default fetchAPI;
